import styled from "styled-components/macro";

export const Subtitle = styled.p`
  margin: 0;
`;

export const TipoSeguroCard = styled.div`
  height: fit-content;
  max-width: 368px;
`;
